import { Button } from '@workspace/ui/components/button'
import { cn } from '@workspace/ui/lib/utils'
import { useState } from 'react'

interface MultiSelectCardProps {
  options: { label: string; value: string }[]
  resolved?: boolean
  selectedValues?: string[]
  onSubmit: (values: string[]) => void
}

export function MultiSelectCard({
  options,
  resolved,
  selectedValues: initialValues,
  onSubmit,
}: MultiSelectCardProps) {
  const [selected, setSelected] = useState<string[]>(initialValues ?? [])

  function toggleOption(value: string) {
    if (resolved) return
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    )
  }

  return (
    <div className="flex min-w-[220px] flex-col gap-3">
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isSelected = (resolved ? (initialValues ?? []) : selected).includes(option.value)
          const isDisabled = resolved && !isSelected

          return (
            <button
              key={option.value}
              type="button"
              disabled={resolved}
              onClick={() => toggleOption(option.value)}
              className={cn(
                'rounded-lg border px-3 py-1.5 text-sm transition-all',
                isSelected
                  ? 'border-[#f97316] bg-[#f97316]/10 text-white'
                  : 'border-border bg-card text-muted-foreground hover:border-[#f97316]/50 hover:text-white',
                isDisabled && 'opacity-30'
              )}
            >
              {option.label}
            </button>
          )
        })}
      </div>
      {!resolved && (
        <Button
          disabled={selected.length === 0}
          onClick={() => onSubmit(selected)}
          size="sm"
          className="w-fit"
        >
          Continue
        </Button>
      )}
    </div>
  )
}
